import React, { useState, useRef, useEffect, } from 'react';

import Loader from 'react-loader-spinner';
import Switch from "react-switch";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp, faAngleDown, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { withFirebase } from '../firebase';

import data from '../../constants/tournament.json';

const TournamentForm = (props) => {

    const userId = props.firebase.auth.currentUser.uid;

    const { onClose, showModal } = props;
    const [tournament, setTournament] = useState(props.tournament);
    const inputFocusRef = useRef();

    useEffect(() => {
        inputFocusRef.current.focus();
        setTournament(props.tournament)
    }, [props.tournament])

    const [saving, setSaving] = useState(false)
    const { _gender, _format } = data;

    const [title, setTitle] = useState(tournament.title || '');
    const [gender, setGender] = useState(tournament.gender || Object.keys(_gender)[0]);
    const [format, setFormat] = useState(tournament.format || Object.keys(_format)[0]);
    const [finalized, setFinalized] = useState(tournament.finalized || false);
    // const [type, setType] = useState(Object.keys(_type)[0]);

    const invalid = title === '';

    const onSubmit = (e) => {
        e.preventDefault();
        if (!invalid && !saving) {
            setSaving(true);

            props.firebase.tournamentDoc(userId, tournament.uid).update({
                title: title,
                gender: gender,
                format: format,
                finalized: finalized
            })
                .then(() => {
                    setSaving(false);
                    onClose();
                })
                .catch((error) => {
                    setSaving(false);
                    console.log("Error: ", error);
                    showModal("Error", "Ocurrió un error al guardar los datos del torneo. Compruebe los datos e intentelo de nuevo.")
                    onClose();
                });
        }
    }

    return (
        <div className="">
            <span className="font-weight-bolder ml-2">Editar Torneo</span>

            <form onSubmit={onSubmit}>

                <div className="row m-0">
                    <div className="col row pl-0 pr-0 m-0">

                        <div className="col-12 col-md-6 p-1">
                            <label className="small text-secondary mb-0 ml-1" htmlFor="title">Nombre del Torneo:</label>
                            <input ref={inputFocusRef} className="form-control form-control-sm" value={title} type="text" onChange={(e) => setTitle(e.target.value)} id="title" name="title" placeholder="..." />
                        </div>

                        <div className="col-6 col-md-3 p-1">
                            <label className="small text-secondary mb-0 ml-1" htmlFor="gender">Género:</label>
                            <select value={gender} onChange={(e) => setGender(e.target.value)} className="form-control form-control-sm" id="gender">
                                {Object.keys(_gender).map((key) =>
                                    <option key={key} value={key}>{_gender[key]}</option>)
                                }
                            </select>
                        </div>

                        <div className="col-6 col-md-3 p-1">
                            <label className="small text-secondary mb-0 ml-1" htmlFor="format">Tipo:</label>
                            <select value={format} onChange={(e) => setFormat(e.target.value)} className="form-control form-control-sm" id="format">
                                {Object.keys(_format).map((key) =>
                                    <option key={key} value={key}>{_format[key]}</option>)
                                }
                            </select>
                        </div>

                    </div>

                    <div className="col-12 p-0 d-inline-flex">
                        <label htmlFor="switch" className="align-self-center m-1 small">
                            <span className="mr-1">Finalizado</span>
                            <Switch
                                onChange={(checked) => setFinalized(checked)}
                                checked={finalized}
                                uncheckedIcon={<p className="small text-white font-weight-bold text-center pt-1">No</p>}
                                checkedIcon={<p className="small text-white font-weight-bold text-center pt-1">Si</p>}
                                onColor="#f44336"
                                offColor="#90a4ae"
                                handleDiameter={16}
                                height={22}
                                width={44}
                                id="switch"
                            />
                        </label>

                        {(!saving) ?
                            <div className="flex-fill d-flex flex-row-reverse p-0 mt-2">
                                <button disabled={invalid} type="submit" className="col-auto btn btn-sm btn-success m-1">Guardar</button>
                                <button onClick={onClose} className="col-auto btn btn-sm btn-secondary m-1">Cancelar</button>
                            </div>
                            :
                            <div className="flex-fill d-flex flex-row-reverse p-0 mt-2">
                                <Loader className=""
                                    type="ThreeDots"
                                    color="#263238"
                                    height={39}
                                    width={50}
                                    timeout={0} />
                            </div>
                        }
                    </div>
                </div>
            </form>
        </div>
    )

}

export default withFirebase(TournamentForm);
